<template>
  <div id="app">
    <TimeZoneSelector/>
  </div>
</template>

<script>
import TimeZoneSelector from "@/components/TimeZoneSelector";

export default {
  name: 'App',
  components: {
    TimeZoneSelector,
  }
}
</script>

<style>
</style>
